export const PLATFORM_CONFIG = {
  FORMAT: {
    DATE: {
      DDMMYYYY: 'dd/MM/yyyy',
      YYYYMMDD: 'yyyy/MM/dd',
      MMYYYY: 'MM/yyyy',
    }
  },
  RECORDS: {
    NUTRITIONAL_HISTORY: {
      MAX_ALLERGIES: 100,
    }
  }
};
